import { FunctionComponent } from "react";
import { useOktaAuth } from '@okta/okta-react';

const Signout: FunctionComponent = () => {

    const { oktaAuth } = useOktaAuth();

    const params = new URLSearchParams(window.location.search);
    const isExtAuth = params.get('isExtAuth') === 'true';
    sessionStorage.setItem("isExtAuth", isExtAuth ? 'true' : '');

    oktaAuth.signOut({
        postLogoutRedirectUri: `${window.location.origin}/logout`
    });


    return (<h3>Signing out...</h3>);
}

export default Signout;